import React from 'react'
import { string, array, number } from 'prop-types'
import Case from 'case'
import { FormattedMessage } from 'react-intl'
import { EMPTY_ARRAY, ALL } from '../../../utils/constants'
import { insightsAttrs } from '../../../utils/insights'
import { urlWithTrack, sendGaEventTracking } from '../../../helpers/common'
import Image from '../../ui/image/Image'
import AdLink from '../../ui/ad-link/AdLink'
import Icon from '../../ui/icon/Icon'
import { widgetMessages as messages } from '../messages'

const GridWidget = ({ type = '', results = EMPTY_ARRAY, view_more: viewMoreUrl = '#', query = '', widgetIndex }) => {
  const trackedViewMoreUrl = urlWithTrack(viewMoreUrl, ALL)

  const renderMoreResultsLink = (type = '', url = '', position = 'top') => (
    <AdLink
      className={`grid-widget__more-results grid-widget__more-results--${position}`}
      href={url}
      onClick={() => sendGaEventTracking('grid-widget', 'view-more-clicked')}
    >
      <span><FormattedMessage {...messages[type + 'Search']} /></span>
      <Icon svg='longRigthArrow' />
    </AdLink>
  )

  return <div className='grid-widget'>
    <div className='grid-widget__header'>
      <h3 className='grid-widget__title'>
        <FormattedMessage {...messages['resultsFor' + Case.pascal(type)]} />
      </h3>
      { renderMoreResultsLink(type, trackedViewMoreUrl) }
    </div>
    <div className='grid-widget__results'>
      { results.slice(0, 4).map(({ title, url, featured_images: images, document_id: docId }, index) => {
        const trackedUrl = urlWithTrack(url, ALL)
        const insightsObject = insightsAttrs({
          category: `search-all-grid-widget-${type}`,
          label: decodeURI(query),
          value: `${type}/${docId}`,
          version: widgetIndex + 1
        })
        return (
          <a href={trackedUrl} key={index} className='grid-widget__result'
            onClick={() => sendGaEventTracking('grid-widget', 'item-clicked')} {...insightsObject}
          >
            <figure>
              <Image src={images['url_medium']} />
            </figure>
            <h4>{title}</h4>
          </a>
        )
      })}
    </div>
    { renderMoreResultsLink(type, trackedViewMoreUrl, 'bottom') }
  </div>
}

GridWidget.propTypes = {
  type: string,
  results: array,
  view_more: string,
  query: string,
  widgetIndex: number
}

export default GridWidget